import type { ToastKind } from "@appsmith/ads";
import type { AnvilCommand } from "./types";

export interface AnvilToastDescriptor {
  kind: ToastKind;
  text: string;
}

/**
 * Pure mapping from a run command to the confirmation toast to show (or null
 * when the command opts out via silentToast). Kept side-effect free so it is
 * unit-testable without the ADS toast runtime.
 */
export function buildCommandRunToast(
  command: AnvilCommand,
): AnvilToastDescriptor | null {
  if (command.silentToast) {
    return null;
  }

  return { kind: "success", text: command.label };
}
